import React from 'react'

const Footer = () => {
  return (
    <>
        <div className="container my-5" id='footer'>
        <footer
                className="text-center text-lg-start text-white"
                >
            <div className="container p-4 pb-0">
            <section className="">
                <div className="row">
                <div className="col-md-3 col-lg-3 col-xl-3 mx-auto mt-3">
                    <h6 className="text-uppercase mb-4 font-weight-bold">
                    CAR Rental
                    </h6>
                    <p>
                    We offer a big range of vehicles for <br/>
                    all your driving needs. We have the <br/>
                    perfect car to meet your needs.
                    </p>
                </div>

                <hr className="w-100 clearfix d-md-none" />

                <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mt-3">
                    <h6 className="text-uppercase mb-4 font-weight-bold">Serve In</h6>
                    <p>
                    <a href='#' className="text-decoration-none" style={{color:"black", cursor:"pointer"}}>MP</a>
                    </p>
                    <p>
                    <a href='#' className="text-decoration-none" style={{color:"black", cursor:"pointer"}}>Delhi</a>
                    </p>
                    <p>
                    <a href='#' className="text-decoration-none" style={{color:"black", cursor:"pointer"}}>Kerala</a>
                    </p>
                    <p>
                    <a href='#' className="text-decoration-none" style={{color:"black", cursor:"pointer"}}>TN</a>
                    </p>
                </div>

                <hr className="w-100 clearfix d-md-none" />

                <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mt-3">
                    <h6 className="text-uppercase mb-4 font-weight-bold">
                    Useful links
                    </h6>
                    <p>
                    <a href='#' className="text-decoration-none" style={{color:"black", cursor:"pointer"}}>Your Account</a>
                    </p>
                    <p>
                    <a href='#' className="text-decoration-none" style={{color:"black", cursor:"pointer"}}>Become an Affiliate</a>
                    </p>
                    <p>
                    <a href='#' className="text-decoration-none" style={{color:"black", cursor:"pointer"}}>Rates</a>
                    </p>
                    <p>
                    <a href='#' className="text-decoration-none" style={{color:"black", cursor:"pointer"}}>Help</a>
                    </p>
                </div>

                <hr className="w-100 clearfix d-md-none" />

                <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mt-3">
                    <h6 className="text-uppercase mb-4 font-weight-bold">Contact</h6>
                    <p><i className="fas fa-home mr-3"></i> Indore, MP 45606, IN</p>
                    <p><i className="fas fa-envelope mr-3"></i> info@gmail.com</p>
                    <p><i className="fas fa-phone mr-3"></i> + 01 234 567 88</p>
                    <p><i className="fas fa-print mr-3"></i> + 01 234 567 89</p>
                </div>
                </div>
            </section>

            <hr className="my-3" />

            <section className="p-3 pt-0">
                <div className="row d-flex align-items-center">
                <div className="col-md-7 col-lg-8 text-center text-md-start">
                    <div className="p-3">
                    © 2023 Copyright:
                    <a className="text-black text-decoration-none link" href="#">
                        CAR Rental
                    </a>
                        
                    </div>
                </div>

                <div className="col-md-5 col-lg-4 ml-lg-0 text-center text-md-end">
                    <a
                    className="btn btn-outline-light btn-floating m-1"
                    role="button"
                    ><i className="fab fa-facebook-f"></i
                    ></a>

                    <a
                    className="btn btn-outline-light btn-floating m-1"
                    role="button"
                    ><i className="fab fa-twitter"></i
                    ></a>

                    <a
                    className="btn btn-outline-light btn-floating m-1"
                    role="button"
                    ><i className="fab fa-google"></i
                    ></a>

                    <a
                    className="btn btn-outline-light btn-floating m-1"
                    role="button"
                    ><i className="fab fa-instagram"></i
                    ></a>
                </div>
                </div>
            </section>
            </div>
        </footer>
        </div>
    </>
  )
}

export default Footer